import * as def from '@/lib/definition'
import { indexOf } from '@/lib/common'

export default {
  enqueueAsync: state => state.asyncQueue.push(true),
  dequeueAsync: state => state.asyncQueue.shift(),
  setUser (state, user) {
    state.user = user
  },
  setEditor (state, props) {
    state.editor = props
  },
  setPage (state, page) {
    state.pages[page.id] = {
      list: [],
      articles: {},
      images: [],
      ...page
    }
  },
  setList (state, { pageId, data }) {
    state.pages[pageId].list = data.articles.map(_article => {
      const article = { ..._article }
      def.dateObjectItems.forEach(key => {
        if (article[key] && article[key].seconds) {
          article[key] = article[key].toDate()
        }
      })
    })
  },
  setArticle (state, { pageId, data }) {
    const article = data
    state.pages[pageId].articles[data.id] = article
    def.dateObjectItems.forEach(key => {
      if (article[key] && article[key].seconds) {
        article[key] = article[key].toDate()
      }
    })
  },
  deleteArticle (state, { pageId, articleId }) {
    delete state.pages[pageId].articles[articleId]
  },
  setCurrentPage (state, article) {
    state.currentPage = article
  },
  clearImages (state, pageId) {
    state.pages[pageId].images = []
  },
  setImage (state, { pageId, data }) {
    def.dateObjectItems.forEach(key => {
      if (data[key] && data[key].seconds) {
        data[key] = data[key].toDate()
      }
    })
    state.pages[pageId].images.push(data)
  },
  deleteImage (state, { pageId, id }) {
    const page = state.pages[pageId]
    const index = indexOf(page.images, 'id', id)
    page.images.splice(index, 1)
  }
}
